import React from 'react'
import './quadrant-loader.scss'
import Title from 'antd/es/typography/Title'

function QuadrantLoader({ text }) {
    return (
        <div className='spinner-container'>
            <div className='spinner'>
                <div className='quadrant'></div>
                <div className='quadrant'></div>
                <div className='quadrant'></div>
                <div className='quadrant'></div>
            </div>
            <Title level={4} type='secondary'>
                {text}
            </Title>
        </div>
    )
}

export default QuadrantLoader
